import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../../configs/api";
import {
  districtOptions,
  cityOptions,
  specializationOptions,
  yearsOfExperienceOptions,
  degreeOptions,
} from "../../../utils/constants";
import { Context } from "../../../Context/AuthContext";
import FileDropzone from "../../ui/FileDropzone";
import { ACCEPT_IMAGES_TYPES_OBJECT, ACCEPT_PDF_TYPES_OBJECT, MAX_SIZE_IMAGE } from "../../../utils/constants";
import ShowingFile from "../../ui/ShowingFile";
import GeneralSelect from "../../ui/custom-inputs/select-inputs/GeneralSelect";
import CustomTextarea from "../../ui/custom-inputs/CustomTextarea";
import { StepTwoSpecialistValidation } from "../RegisterValidation";
import CustomInput from "../../ui/custom-inputs/CustomInput";
function SpecialistStepTwo({ setStep, formData, setFormData, handleChange }) {

  const [specialistImage, setSpecialistImage] = useState(formData?.specialistImage?.length ? formData?.specialistImage : []);
  const [graduationCertificate, setGraduationCertificate] = useState(formData?.graduationCertificate?.length ? formData?.graduationCertificate : []);
  const [resume, setResume] = useState(formData?.resume?.length ? formData?.resume : []);
  const [cardId, setCardId] = useState(formData?.cardId?.length ? formData?.cardId : []);
  const [formErrors, setFormErrors] = useState({});

  const { values } = useContext(Context);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = StepTwoSpecialistValidation(formData)
    console.log(err);
    if (Object.keys(err).length === 0) {
      try {

        const response = await api.post("/register/new_specialist", {
          ...formData,
          image: formData?.specialistImage?.[0].fileUrl,
          graduationCertificate: formData?.graduationCertificate?.[0].fileUrl,
          resume: formData?.resume?.[0].fileUrl,
          ID_card: formData?.cardId?.[0].fileUrl,
        });

        Swal.fire({
          icon: "success",
          title: " تم ارسال طلبك للتحقق ",
          text: "يمكنك استخدام ظل بعد قبول الطلب",
          customClass: "swal-wide",
        });
        values.logIn.setIsLog(true);

        navigate("/");
      } catch (error) {
        console.error("API error:", error);
        const errorMessage = error?.response?.data?.error;

        Swal.fire({
          icon: "error",
          title: "نعتذر هنالك خطأ ما!",
          text: errorMessage,
          customClass: "swal-wide",
        });
      }
    } else {
      setFormErrors(err);
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    setStep(1);
  };

  useEffect(() => {
    setFormData({
      ...formData,
      specialistImage,
      graduationCertificate,
      resume,
      cardId,
    })
  }, [specialistImage, graduationCertificate, resume, cardId])

  return (
    <>
      <form
        className=' border p-3 shadow-md rounded-md text-sm  w-[20rem] sm:w-[27rem] bg-[#bbb9b4]'
        onSubmit={handleSubmit}
      >
        <div className=' flex justify-between'>
          <h4 className=' text-primary4 text-sm'> خطوة 2 من اصل 2</h4>
          <h4 className='text-primary4'> بيانات تفصيلية</h4>
        </div>
        <div className='w-full bg-gray-200 rounded-full h-1  relative mt-3'>
          <div className='bg-primary h-1 rounded-full  absolute right-0 w-full '></div>
        </div>
        <br />

        <div className="flex flex-col gap-y-2 items-center text-center mb-4 text-primary4">
          <label>الصورة الشخصية</label>

          {specialistImage.length > 0 ?
            <img className="w-[200px] h-[200px] rounded-full bg-primary4" src={specialistImage?.[0]?.fileUrl} alt="specialist" />
            :
            <FileDropzone
              setState={setSpecialistImage}
              value={specialistImage}
              filesAccept={ACCEPT_IMAGES_TYPES_OBJECT}
              name="specialistImage"
              maxSize={MAX_SIZE_IMAGE}
            />
          }
        </div>

        <label className='text-primary4 flex flex-col items-end mb-1'>نبذة قصيرة</label>
        <CustomTextarea
          name='brief'
          placeholder='ادخل معلومات عامة عنك'
          rows='4'
          dir='rtl'
          cols='50'
          className=' border rounded p-2 w-full'
          onChange={handleChange}
          value={formData.brief || ""}
        />
        {formErrors?.brief && (
          <>
            <p className=' text-xs text-red-500' dir='rtl'>
              {formErrors?.brief}
            </p>
          </>
        )}
        <br />
        <label htmlFor="city" className='w-full flex flex-col text-end md:mr-4 text-primary4 gap-1'>
          المدينة
          <CustomInput
            type='text'
            name='city'
            value={formData.city || ""}
            onChange={handleChange}
            placeholder='أدخل المدينة ...'
            dir='rtl'
          />  </label>
        {formErrors?.city && (
          <>
            <p className=' text-xs text-red-500' dir='rtl'>
              {formErrors?.city}
            </p>
          </>
        )}
        <br />
        <label htmlFor="district" className='w-full flex flex-col text-end md:mr-4 text-primary4 gap-1'>
          الحي
          <CustomInput
            type='text'
            name='district'
            value={formData.district || ""}
            onChange={handleChange}
            placeholder='أدخل الحي ...'
            dir='rtl'
          />  </label>
        {formErrors?.district && (
          <>
            <p className=' text-xs text-red-500' dir='rtl'>
              {formErrors.district}
            </p>
          </>
        )}

        <br />
        <label
          htmlFor='specialization'
          className='block mb-2 text-sm font-medium  text-end text-primary4'
        >
          التخصص
        </label>
        <GeneralSelect
          options={specializationOptions}
          handleChange={(val) => {
            setFormData({ ...formData, specialization: val?.value })
          }}
          defaultValue={formData?.specialization}
          name={"specialization"}
        />
        {formErrors?.specialization && (
          <>
            <p className=' text-xs text-red-500' dir='rtl'>
              {formErrors?.specialization}
            </p>
          </>
        )}
        <br />
        <div className=' flex mt-3 mb-3 md:flex-row flex-col'>
          <label htmlFor="degree" className='w-full flex flex-col text-end text-primary4 gap-1'>
            الدرجة العلمية
            <GeneralSelect
              options={degreeOptions}
              handleChange={(val) => {
                setFormData({ ...formData, degree: val?.value })
              }}
              defaultValue={formData?.degree}
              name={"degree"}
            />
            {formErrors?.degree && (
              <>
                <p className=' text-xs text-red-500'>
                  {formErrors?.degree}
                </p>
              </>
            )}
          </label>
          <label htmlFor="yearsOfExperience" className='w-full flex flex-col text-end md:ml-4 text-primary4'>
            سنوات الخبرة
            <CustomInput
              type='number'
              name='yearsOfExperience'
              value={formData.yearsOfExperience || ""}
              onChange={handleChange}
              placeholder='أدخل سنوات الخبرة ...'
              dir='rtl'
            />
            {formErrors?.yearsOfExperience && (
              <>
                <p className=' text-xs text-red-500'>
                  {formErrors?.yearsOfExperience}
                </p>
              </>
            )}
          </label>
        </div>
        {/* Files */}
        <div className="grid gap-4" dir="rtl">
          <div>
            <label className="text-primary4">بطاقة الهوية</label>
            {cardId?.length === 0 ?
              <FileDropzone
                setState={setCardId}
                value={cardId}
                filesAccept={{ ...ACCEPT_IMAGES_TYPES_OBJECT, ...ACCEPT_PDF_TYPES_OBJECT }}
                name="specialistImage"
                maxSize={MAX_SIZE_IMAGE}
              />
              :
              <ShowingFile values={cardId} setValues={setCardId} />
            }
          </div>
          <div>
            <label className="text-primary4">السيرة الذاتية</label>
            {resume?.length === 0 ?
              <FileDropzone
                setState={setResume}
                value={resume}
                filesAccept={{ ...ACCEPT_IMAGES_TYPES_OBJECT, ...ACCEPT_PDF_TYPES_OBJECT }}
                name="specialistImage"
                maxSize={MAX_SIZE_IMAGE}
              />
              :
              <ShowingFile values={resume} setValues={setResume} />
            }
          </div>
          <div>
            <label className="text-primary4">شهادة التخرج</label>
            {graduationCertificate?.length === 0 ?
              <FileDropzone
                setState={setGraduationCertificate}
                value={graduationCertificate}
                filesAccept={{ ...ACCEPT_IMAGES_TYPES_OBJECT, ...ACCEPT_PDF_TYPES_OBJECT }}
                name="specialistImage"
                maxSize={MAX_SIZE_IMAGE}
              />
              :
              <ShowingFile values={graduationCertificate} setValues={setGraduationCertificate} />
            }
          </div>
        </div>
        <br />
        <div className=' flex'>
          <button
            onClick={handleClick}
            className=' text-center border  text-primary border-primary rounded-xl h-10 w-2/5 mr-3 texts'
          >
            رجوع للسابق
          </button>
          <input
            value='حفظ وإنشاء حساب جديد
              '
            type='submit'
            className=' text-center border-2 bg-primary w-3/4 text-primary4 rounded-xl h-10 cursor-pointer '
          />
        </div>
      </form>
    </>
  );
}

export default SpecialistStepTwo;
